<template>
  <div class="home-banner">
    <Transition name="fade">
      <el-carousel v-if="sliders.length" height="500px" :interval="5000">
        <el-carousel-item v-for="item in sliders" :key="item._id">
          <RouterLink target="_blank" :to="`${item.bannerUrl}`">
            <img
              style="width: 1902px; height: 500px"
              v-lazy="item.bannerImg"
              alt=""
            />
          </RouterLink>
        </el-carousel-item>
      </el-carousel>
      <HomeBannerSkeleton v-else />
    </Transition>
  </div>
</template>
<script>
import { ref } from "vue";
import { findBanner } from "@/api/home";

import HomeBannerSkeleton from "./home-banner-skeleton.vue";
export default {
  name: "HomeBanner",
  components: { HomeBannerSkeleton },
  setup() {
    const sliders = ref([]);
    findBanner(1719394537759)
      .then((data) => {
        sliders.value = data;
      })
      .catch((error) => {
        console.log(error);
      });
    return { sliders };
  },
};
</script>
<style lang="less" scoped>
.home-banner {
  width: 100%;
  height: 500px;
  position: absolute;
  background-size: cover; /* 背景图片覆盖整个容器 */
  background-position: center; /* 背景图片居中 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  left: 0;
  top: 130px;
  z-index: 98;
}
.el-carousel__arrow--left {
  left: 30%;
  &:hover {
    color: @shColor;
  }
}
.el-carousel__arrow--right {
  right: 15%;
  &:hover {
    color: @shColor;
  }
}
</style>
